import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps, Modal, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { getWorkflowStepDisplayName } from "src/business/workflow/getWorkflowStepDisplayName";
import { ZWorkflowStep } from "src/business/workflow/ZWorkflowStep";
import { onError } from "src/common/onError";
import { msgQueueStore } from "src/components/MsgQueue";
import { WorkflowIcon } from "src/icons";

import { WfRecordCardStore } from "./wfRecordCardStore";

type PropsStepActionsDropdown = {
  pageStore: WfRecordCardStore;
};

export const StepActionsDropdown: React.FC<PropsStepActionsDropdown> = observer(
  ({ pageStore }) => {
    const navigate = useNavigate();
    const [modal, contextHolder] = Modal.useModal();
    const { hasUnsavedChanges } = pageStore;
    const hasSteps = pageStore.availableSteps.length > 0;
    const disabled = hasUnsavedChanges || !hasSteps;

    const handleStepClick = (step: ZWorkflowStep) => {
      const stepName = getWorkflowStepDisplayName(step);
      const workflowCardTitle = pageStore.title;
      const runTransition = () =>
        pageStore
          .goToNextStep(step.id, navigate)
          .then(() => {
            msgQueueStore.add({
              type: "success",
              message: step.lastStep
                ? "Рабочая версия записи утверждена"
                : "Рабочая версия записи перемещена на следующий шаг",
              ...(!step.lastStep && {
                description: `Шаг: «${stepName}». Рабочая версия: «${workflowCardTitle}».`,
              }),
            });
          })
          .catch(onError);

      if (!step.lastStep) {
        runTransition();
        return;
      }

      modal.confirm({
        type: "warning",
        title: "Утвердить рабочую версию?",
        content: `Утверждение рабочей версии создаст запись в каталоге "${pageStore.catalogName ?? ""}" и удалит версию из рабочего потока.`,
        okText: "Утвердить",
        cancelText: "Отмена",
        onOk: () => runTransition(),
      });
    };

    const items: MenuProps["items"] = [
      {
        key: "title",
        label: "Переместить на шаг:",
        disabled: true,
      },
      ...pageStore.availableSteps.map((step: ZWorkflowStep) => ({
        key: step.id,
        label: getWorkflowStepDisplayName(step),
        icon: <WorkflowIcon />,
        onClick: () => handleStepClick(step),
      })),
    ];

    const button = (
      <Button disabled={disabled} icon={<DownOutlined />} iconPosition="end">
        Действия
      </Button>
    );

    if (hasUnsavedChanges) {
      return (
        <>
          {contextHolder}
          <Tooltip title="Карточка содержит несохраненные изменения">
            <span>{button}</span>
          </Tooltip>
        </>
      );
    }

    return (
      <>
        {contextHolder}
        <Dropdown menu={{ items }} trigger={["click"]}>
          {button}
        </Dropdown>
      </>
    );
  },
);
